
import { mapState, mapActions } from "vuex";
import serviceInterruption from "~/assets/images/service-interruption.svg";
import CurrencyConverter from "../common/currency-converter.vue";
import LocationOnlineStatusHandler from "../reciever/location-online-status-handler.vue";

export default {
  components: { LocationOnlineStatusHandler, CurrencyConverter },
  props: {
    showDialog: Boolean
  },
  data() {
    return {
      serviceInterruption,
      showPaymentBanner: true
    };
  },
  computed: {
    ...mapState("restaurant", ["subscription"])
  }
};
